import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme, { order }: { order?: number }) => ({
  collection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._24,
    order,
  },
}));
